import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DsDevice } from 'src/app/ds/model/ds-device';
import { DsDeviceFormatter } from 'src/app/ds/util/ds-device-formatter';
import { FieldType } from 'src/app/settings/model/field-type';
import { ValueField } from 'src/app/settings/model/value-field';
import { DataOptionsComponent } from 'src/app/shared/component/data-options/data-options.component';
import { DataSource, SortBy } from 'src/app/shared/model/data-source';
import { DataSourceCreator } from 'src/app/shared/util/data-source-creator';

export const current = 'current';
export const wifi = 'wifi';
export const gsm = 'gsm';
const sideNumber = 'sideNumber';
const lastLoginAt = 'lastLoginAt';
const syncTimestamp = 'syncTimestamp';

const dsDeviceFields: ValueField[] = [
  Object.assign(new ValueField(), {
    name: 'sideNumber',
    type: FieldType.TEXT,
    visible: true,
    primaryKey: true,
    canFilter: true
  }),
  Object.assign(new ValueField(), {
    name: lastLoginAt,
    type: FieldType.DATETIME,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: wifi,
    type: FieldType.BOOLEAN,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: gsm,
    type: FieldType.BOOLEAN,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: current,
    type: FieldType.BOOLEAN,
    visible: true
  }),
  Object.assign(new ValueField(), {
    name: syncTimestamp,
    type: FieldType.DATETIME,
    visible: true
  })
];

@Component({
  selector: 'app-ds-device-selector',
  templateUrl: './device-selector.component.html',
  styleUrls: ['./device-selector.component.scss']
})
export class DsDeviceSelectorComponent implements AfterViewInit {
  @ViewChild('dataOptions')
  dataOptions: DataOptionsComponent;
  @Output()
  private dataSourceSelected = new EventEmitter<DataSource>();

  constructor(private dataSourceCreator: DataSourceCreator) { }

  ngAfterViewInit(): void {
    const dataSource = this.dataSourceCreator.create(DsDevice.getName(), dsDeviceFields);
    dataSource.sortBy = [new SortBy(sideNumber, 'asc')];
    dataSource.addTableCellFormatter(current, new DsDeviceFormatter(current));
    dataSource.addTableCellFormatter(wifi, new DsDeviceFormatter(wifi));
    dataSource.addTableCellFormatter(gsm, new DsDeviceFormatter(gsm));
    this.dataOptions.setDataSource(dataSource);
    this.dataSourceSelected.emit(dataSource);
  }
}
